import PointerCoordinates from "../pointerCoordinates/PointerCoordinates";

export default function HomeCoordinates() {
  return <PointerCoordinates activeSection={0} className="homepage-coordinates" />;
}
